import { View as RNView } from "react-native";
import { withLayoutProps, type WithLayoutProps } from "~/hoc/withLayoutProps";
import type React from "react";
import type { ViewProps as RNViewProps } from "react-native";

export const View = withLayoutProps(RNView);
export type View = React.ElementRef<typeof RNView>;
export type ViewProps = Omit<RNViewProps, keyof WithLayoutProps> &
  WithLayoutProps;
